import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Header from "../../components/Header";
import { FormattedMessage } from "react-intl";
import CertificateProductSelection from "../../components/Certificates/CertificateProductSelection";
import CertificatePdfUpload from "../../components/Certificates/CertificatePdfUpload";

function CertificatesUpload({ history }) {
  return (
    <>
      <Header>
        <h1>
          <FormattedMessage id="certificates.title" defaultMessage="Certificates" />
        </h1>
      </Header>
      <Container fluid>
        <Row>
          <Col>
            <Card>
              <CardBody>
                <Row>
                  <Col>
                    <p className="card-text">
                      <FormattedMessage id="certificates.upload_certificate.description" defaultMessage="Select a PDF to upload." />
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col className="mt-3">
                    <CertificatePdfUpload history={history}></CertificatePdfUpload>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default CertificatesUpload;
